import React from "react";
import "../App.css";
import "../index.css";
import { Link } from "react-router-dom";

const ListItem = ({
  name,
  coinName,
  numberOfPcs,
  imageProp,
  PostTimeStamp,
  Hopper_Total_OUT2,
  coinName2,
  coin2,
  IdMachine,
}) => {
  const trueImage = process.env.PUBLIC_URL + "/red.svg";
  const falseImage = process.env.PUBLIC_URL + "/green.svg";
  return (
    <Link
      to={`/detail/${IdMachine}`}
      className="list-item"
      style={{
        textDecoration: "none",
        background: "rgba(191, 221, 251, 0.29)",
        borderRadius: "16px",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(7.6px)",
        WebkitBackdropFilter: "blur(7.6px)",
        border: "1px solid rgba(191, 221, 251, 0.3)",
        color: "inherit",
        width: "80%",
        height: coin2 ? "200px" : "100px",
        marginBottom: "30px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        alignItems: "center",
        padding: "0.5em",
      }}
    >
      <img
        src={imageProp ? trueImage : falseImage} // Use the imageProp to choose the image
        style={{
          position: "absolute", // Position the image absolutely
          top: "10px", // 10px from the top
          right: "10px", // 10px from the right
        }}
        title={`Naposledy aktualizováno ${PostTimeStamp}`}
      />
      <div style={{ textAlign: "left" }}>
        <h3>{name}</h3>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          <p>{coinName}</p>
          <p
            style={{
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
            }}
          >
            {numberOfPcs} ks
          </p>
        </div>
        {coin2 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p>{coinName2}</p>
            <p
              style={{
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
              }}
            >
              {Hopper_Total_OUT2} ks
            </p>
          </div>
        )}
      </div>
    </Link>
  );
};

export default ListItem;
